import request from '@/utils/request'

export function addAddress (data) {
  return request({
    url: '/front/address/',
    method: 'post',
    data
  })
}

export function myAddressList () {
  return request({
    url: '/front/address/',
    method: 'get'
  })
}

export function myAddressDetail (addressId) {
  return request({
    url: '/front/address/' + addressId + '/',
    method: 'get'
  })
}

export function editAddress (addressId, data) {
  return request({
    url: '/front/address/' + addressId + '/',
    method: 'put',
    data
  })
}

export function deleteAddress (addressId) {
  return request({
    url: '/front/address/' + addressId + '/',
    method: 'delete'
  })
}
